import  codes from '@/codes'

export default {
  name: 'RuleIP',
  props: ['setting', 'user', 'is_first'],
  computed: {},
  watch: {
    setting() {
      this.server = Object.assign({}, this.server, { level : this.setting.level, mode : this.setting.mode })
    }
  },
  data: () => {
    return {
      codes,
      explain_ip_allow :false,
      explain_ip_block_or_detect : false,
      model : { allow_ip : '', block_ip : '' },
      server : { mode : 0, level : 1 }
    }
  },
  methods: {
    refresh() {
      // some action here
      this.$parent.$emit("refresh")
    },
    change() {
      // 2 초기에는 안됨
      // TODO : 추가적으로 설정 필요
      this.server.mode += 1



      if(this.is_first) {
        if(this.server.mode > codes.WAF_MODE_DETECTIONONLY.VALUE) {
          this.server.mode = codes.WAF_MODE_OFF.VALUE
        }
      } else {
        if(this.server.mode > codes.WAF_MODE_ON.VALUE) {
          this.server.mode = codes.WAF_MODE_OFF.VALUE
        }
      }

      this.update(this.server.mode, 'mode')
    },
    update($value, key) {
      console.log('update Rule.Mode => parent', $value, key)
      this.$parent.$emit('update', $value, key)
    }
  },
  created: function() {   console.log('Rule.Mode.vue', 'created'); },
  destroyed: function() { console.log('Rule.Mode.vue', 'destroyed'); },
  mounted: function() {
    console.log('Rule.Mode.vue', 'mounted');
    // console.log('this.setting', this.setting)
    this.server = Object.assign({}, this.server, { level : this.setting.level, mode : this.setting.mode })
  }

}
